import { Accordion, Flex, Grid, Image, Text } from '@raskrask-dk/rr-components'
import { TabsGroupProps } from '@raskrask-dk/rr-components/lib/Molecules/TabsGroup/props'
import i18n, { TFunction } from 'i18next'

export const focusTab = (
    focusTabName: string
): { value: string; label: string; content: JSX.Element } => {
    return {
        value: 'focus',
        label: focusTabName,
        content: (
            <Grid
                gap={8}
                css={{
                    maxW: 650,
                }}
            >
                {
                    // 3 'hardcoded' accordions
                    [1, 2, 3].map((num) => (
                        <Accordion
                            key={num}
                            content={
                                <Text css={{ whiteSpace: 'pre-line' }}>
                                    {i18n.t(
                                        `calendar.modal.focus.${num}.content`
                                    )}
                                </Text>
                            }
                            title={
                                <Flex alignItems="center" gap={16}>
                                    <Image
                                        src={i18n.t(
                                            `calendar.modal.focus.${num}.icon`
                                        )}
                                        css={{ size: 20 }}
                                    />
                                    <Text>
                                        {i18n.t(
                                            `calendar.modal.focus.${num}.title`
                                        )}
                                    </Text>
                                </Flex>
                            }
                        />
                    ))
                }
            </Grid>
        ),
    }
}

const personalTrainingTabsMaker = (t: TFunction): TabsGroupProps['tabs'] => {
    const focusTabName = t('calendar.modalnav.focus')
    return [focusTab(focusTabName)]
}

export { personalTrainingTabsMaker }
